import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import EntityId from '../../foundation/domain/EntityId';
import Page from './Page';
import { Form, Input, Button, Breadcrumb } from 'semantic-ui-react';

import 'brace/mode/xml';
import 'brace/theme/monokai';
import Course from '../modules/lessons/domain/aggregates/course/Course';
import CourseApi from '../modules/lessons/api/CourseApi';
import {Link} from 'react-router-dom';
import Registry from '../global/Registry';
import CourseVisibility from '../modules/lessons/domain/aggregates/course/CourseVisibility';

interface Props {
	id?: string;
	visibility: CourseVisibility;
}

interface State {
	course?: Course;
}

export default class EditCoursePage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = {};
	}

	async componentWillMount () {
		const courses = await CourseApi.getInstance().getAll();

		const visibility = new CourseVisibility(this.props.location.pathname.includes('organization') ? CourseVisibility.ORGANIZATION : CourseVisibility.PRIVATE);

		const courseIdValue = this.props.match.params.id;
		const course = courseIdValue === undefined ? Course.create(Registry.getInstance().me.getId(), visibility) : await courses.find(course => course.getId().equals(new EntityId<Course>(Number(courseIdValue)))) as Course;

		this.setState({course});
	}

	protected saveCourse = async (event: Event) => {
		event.preventDefault();

		let course = this.state.course as Course;

		course = await CourseApi.getInstance().save(course);

		Page.navigate(course.getSlug());
	}

	protected isLoading () {
		return this.state.course === undefined;
	}

	protected renderTitle () {
		return (this.state.course as Course).getName();
	}

	protected renderDescription () {
		return 'Learn ' + (this.state.course as Course).getName() + ' and other courses at our digital education platform.';
	}

	protected renderContent () {
		const course = this.state.course as Course;
		const isNew = !course.hasId();

		const sections = [
			{ key: 'Home', content: <Link to='/'>Home</Link> },
			{ key: 'Course', content: !isNew ? <Link to={course.getSlug()}>{course.getName()}</Link> : course.getName() === '' ? 'New course' : course.getName(), active: !course.hasId() }
		];

		if (course.hasId()) {
			sections.push({ key: 'Rename', content: 'Rename', active: true });
		}

		return (
			<div className='lesson'>
				<Breadcrumb icon='right angle' sections={sections} />

				<Form inverted onSubmit={this.saveCourse} style={{marginTop: '24px', textAlign: 'center'}}>
					<Form.Field>
						<label>{isNew ? 'Give your new course a name' : 'Course name'}</label>
						<Input autoFocus transparent placeholder='Type a name here' style={{ color: 'white' }} value={course.getName()} onChange={(event: any) => this.setState({course: course.updateName(event.target.value)})} />
					</Form.Field>
					<Form.Field>
						<Button primary fluid style={{marginTop: '2em'}}>Save course</Button>
					</Form.Field>
				</Form>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/EditCoursePage.tsx